module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-viewport",
    attrs: {
      "id": "app"
    }
  }, [_c('md-whiteframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toolbarActive),
      expression: "toolbarActive"
    }],
    staticClass: "main-toolbar",
    attrs: {
      "md-elevation": "3"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-dense"
  }, [_c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRouterPath('home')),
      expression: "!isRouterPath('home')"
    }],
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('md-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.blh),
      expression: "blh"
    }]
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', [_vm._v("V2.9.1")]), _vm._v(" "), _c('md-menu-item', {
    on: {
      "selected": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Sair")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cc37254","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 825
// module chunks = 1